/** Geometry shared by the editable document and the canonical renderer.
 * Keep the existing typography: changing it would invalidate saved field coordinates.
 */
export const SIGNATURE_DOCUMENT_WIDTH_PX = 794;
export const SIGNATURE_DOCUMENT_PAGE_HEIGHT_PX = 1123;
export const SIGNATURE_DOCUMENT_PADDING = "48px 64px";
export const SIGNATURE_DOCUMENT_FONT_FAMILY = '"Arimo", "Arial", "Helvetica", sans-serif';
export const SIGNATURE_DOCUMENT_FONT_SIZE_PX = 14;
export const SIGNATURE_DOCUMENT_LINE_HEIGHT = 1.6;

/** ProseMirror adds a presentation-only break after an authored trailing hard break.
 * Plain HTML needs the same line box; removing the authored break loses user content.
 */
export function preserveSignatureTrailingLineBreaks(root: Element): void {
  root.querySelectorAll("p, h1, h2, h3, h4, h5, h6").forEach((block) => {
    let last: ChildNode | null = block.lastChild;
    while (last?.lastChild) last = last.lastChild;
    if (last?.nodeName !== "BR") return;
    if ((last as Element).hasAttribute("data-webot-trailing-break")) return;
    const sentinel = block.ownerDocument.createElement("br");
    sentinel.setAttribute("data-webot-trailing-break", "true");
    block.appendChild(sentinel);
  });
}
